// extracted by mini-css-extract-plugin
export var accessDeniedContainer = "AccessDeniedPage-module__accessDeniedContainer___Cddys";
export var columnWrapper = "AccessDeniedPage-module__columnWrapper___kHEfy";
export var contentBox = "AccessDeniedPage-module__contentBox___T8Fyl";
export var contentColumn = "AccessDeniedPage-module__contentColumn___H78Rw";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var errorPage = "AccessDeniedPage-module__errorPage___BarPU";
export var image = "AccessDeniedPage-module__image___lDZhj";
export var pageFootNote = "AccessDeniedPage-module__pageFootNote___1QIjY";
export var pageSectionDark = "#151517";
export var partnerLinkGlyphRest = "#71BB88";
export var supportButton = "AccessDeniedPage-module__supportButton___Vo43M";